import type { Plugin } from './plugin'
import { State } from './state'

/**
 * Selectors for the records bulk comment workflow.
 */
export class Selectors {
  /** Whether a bulk comment is in progress */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isUpdating

  /** Comment as edited by the user */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly comment

  /** Whether a bulk comment request is in flight */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isSubmitting

  /** Error from the last bulk comment request, if there was one */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(plugin: Plugin) {
    this.isUpdating = plugin.feature.state.project(State.isUpdating)
    this.comment = plugin.feature.state.project(state => state.comment ?? '')
    this.isSubmitting = plugin.feature.state.project(state => state.isSubmitting)
    this.error = plugin.feature.state.project(state => state.error)
  }
}
